// Translation files for multi-language support.
//
// Each language lives in its own module; see fi.js for the shared conventions.
// t() has no fallback, so all three must define the same keys - enforced by
// frontend/scripts/check-translations.js.

import fi from './fi';
import en from './en';
import sv from './sv';

export const translations = { fi, en, sv };
